import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  BuildOutlined,
  ToolOutlined,
  SafetyOutlined,
  RiseOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <BuildOutlined />,
  1: <ToolOutlined />,
  2: <SafetyOutlined />,
  3: <DollarOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("eam");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-eam-section dev-eam-benefits-section">
      <div className="dev-eam-section-inner">
        <h2 className="dev-section-h2 dev-eam-section-h2">
          <span className="dev-eam-section-h2-icon dev-eam-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-eam-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-eam-benefit-card">
              <div className="dev-eam-benefit-left">
                <span className="dev-eam-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-eam-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-eam-benefit-body">
                <div className="dev-eam-benefit-title">{item.title}</div>
                <div className="dev-eam-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
